import { Getters } from "vuex";
import { SnackbarGetters, SnackbarState } from "./types";

export const getters: Getters<SnackbarState, SnackbarGetters> = {};
